import {useIcon} from '../icon/useIcon'
import {Show, createEffect, createSignal, on, onMount} from 'solid-js'
import './soloNoInternetScreen.css'
import {useI18n} from '../../i18n'
import {FocusGroupProvider, FocusableProvider} from '../focus'
import {useSpatialNavigation} from '../../spatialNavigation'
import {useConfig} from '../config/useConfig'

export const SoloNoInternetScreen = (props: any) => {
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()
    const icons = useIcon()
    const {setFocus} = useSpatialNavigation()

    onMount(() => {
        setFocus("reconnect_key")
    })

    return (
        <FocusGroupProvider id={`noEDSConnectivity`} focusKey={`noEDSConnectivity`} onFocus={() => {}}>
            <div class="edsConnectivity-container">
                <div class="edsConnectivity-container-item">
                    {props.eDSConnectivity === "PENDING" ? 
                    <div class="checkingConnection">
                        {getI18n()?.formatMessage({id: 'CHECKING_CONNECTION'})}
                    </div> :
                    <div class='edsConnectivity-content'>
                        {<div class="client_logo_loading_logout_screen"></div>}
                        <div>
                            <label class="edsConnectivity edsConnectivityTitle" for="edsConnectivity">
                                {getI18n()?.formatMessage({id: 'NOCONNECTION'})}
                            </label>
                        </div>
                        <div>
                            <label class="edsConnectivity" for="edsConnectivity">
                                {getI18n()?.formatMessage({id: 'NOINTERNET_MESSAGE1'})}
                            </label>
                        </div>
                        <div>
                            <label class="edsConnectivity" for="edsConnectivity">
                                {getI18n()?.formatMessage({id: 'NOINTERNET_MESSAGE2'})}
                            </label>
                        </div>
                        <div class="noInternet-button-container">
                            <FocusableProvider id={'reconnect_key'} focusKey={`reconnect_key`} onEnterPress={props.checkEDSConnectivity}>
                                {(focused: any) => (
                                    <button
                                        class={`noInternet-content-button-tv-new ${focused?.() ? 'noInternet-content-button-tv-new-focus' : ''}`}
                                        onClick={props.checkEDSConnectivity}
                                        tabIndex={focused?.() ? 0 : -1}
                                    >
                                        {getI18n()?.formatMessage({id: 'RECHECK_BUTTON'})}
                                    </button>
                                )}
                            </FocusableProvider>
                        </div>
                    </div>}
                </div>
            </div>
        </FocusGroupProvider>
    )
}